import React, { FC } from "react";

import {
    ListActivities,
    ListFamily,
    ListHouse,
    ListLegalProtections,
    ListLeisure,
    ListManager,
    ListOther,
    ListPack,
    ListSavings,
    ListVehicle,
    ListWorld,
} from "@/assets/images/categories/list";

export const ContractImage: FC<{ categoryId: string }> = ({ categoryId }) => {
    switch (categoryId) {
        case "-1":
            return <ListOther className="imageType" />;
        case "1":
            return <ListVehicle className="imageType" />;
        case "2":
            return <ListHouse className="imageType" />;
        case "3":
            return <ListFamily className="imageType" />;
        case "4":
            return <ListLeisure className="imageType" />;
        case "5":
            return <ListSavings className="imageType" />;
        case "6":
            return <ListPack className="imageType" />;
        case "7":
            return <ListLegalProtections className="imageType" />;
        case "8":
            return <ListActivities className="imageType" />;
        case "9":
            return <ListWorld className="imageType" />;
        case "10":
            return <ListManager className="imageType" />;
        default:
            return null;
    }
};
